import React from "react";
import { useNavigate } from "react-router-dom";
import { compareStore, useCompareIds } from "@/lib/compareStore";
import { toast } from "sonner";
import { Scale, Check } from "lucide-react";

export default function CompareButton({ schoolId, variant = "pill" }) {
  const ids = useCompareIds();
  const nav = useNavigate();
  const inList = ids.includes(schoolId);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inList) {
      compareStore.remove(schoolId);
      toast("Dihapus dari perbandingan");
      return;
    }
    const res = compareStore.add(schoolId);
    if (!res.ok && res.reason === "full") {
      toast.error(`Maksimal ${compareStore.MAX} sekolah — buka halaman perbandingan lebih dulu.`, {
        action: { label: "Buka", onClick: () => nav("/compare") },
      });
      return;
    }
    toast.success("Ditambahkan ke perbandingan", {
      action: { label: "Bandingkan", onClick: () => nav("/compare") },
    });
  };

  if (variant === "pill") {
    return (
      <button
        onClick={toggle}
        data-testid={`compare-toggle-${schoolId}`}
        className={
          "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs border transition-colors duration-200 " +
          (inList
            ? "bg-[#1E3A8A] text-white border-[#1E3A8A]"
            : "bg-white text-[#1E3A8A] border-[#EAE7E0] hover:bg-[#EEF2FF]")
        }
      >
        {inList ? <Check size={12} /> : <Scale size={12} />}
        {inList ? "Dibandingkan" : "Bandingkan"}
      </button>
    );
  }
  return (
    <button
      onClick={toggle}
      data-testid={`compare-toggle-${schoolId}`}
      className={
        "inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border transition-colors duration-200 " +
        (inList
          ? "bg-[#1E3A8A] text-white border-[#1E3A8A]"
          : "bg-white text-[#1E3A8A] border-[#EAE7E0] hover:bg-[#EEF2FF]")
      }
    >
      {inList ? <Check size={14} /> : <Scale size={14} />}
      {inList ? "Dibandingkan" : "Tambah ke perbandingan"}
    </button>
  );
}
